import "./index.modules.css";
import React from 'react';
import styles from "./index.modules.json";
export var Toast = function Toast() {
  return /*#__PURE__*/React.createElement("div", {
    id: "toast",
    className: styles.toast
  });
};
export var showToast = function showToast(message, duration) {
  var toast = document.getElementById('toast');
  toast.innerHTML = message;
  toast.style.opacity = '1';
  setTimeout(function () {
    toast.style.opacity = '0';
  }, duration || 2000);
};
